export function formatScore(score) {
  if (score === null || score === undefined) return "—";
  return `${Math.round(score)}%`;
}

export function scoreBadgeClass(score) {
  if (score === null || score === undefined) return "bg-gray-100 text-gray-600 border-gray-200";
  if (score >= 75) return "bg-leaf text-white";
  if (score >= 40) return "bg-amber text-white";
  return "bg-clay text-white";
}

export function classificationClass(cls) {
  if (cls === "GREEN") return "bg-leaf/10 text-leaf border-leaf/20";
  if (cls === "YELLOW") return "bg-amber/10 text-amber border-amber/30";
  if (cls === "RED") return "bg-clay/10 text-clay border-clay/30";
  return "bg-gray-100 text-gray-600";
}

// Worst-case classification across an item's materials.
// RED > YELLOW > GREEN. Used to put a single pill on cards / detail pages.
// Honors `override_classification` (set when a material has been re-classified
// thanks to a certification) the same way the backend does.
export function effectiveClassification(materials) {
  if (!materials || !materials.length) return null;
  const set = new Set(materials.map((m) => m.override_classification || m.material_classification));
  if (set.has("RED")) return "RED";
  if (set.has("YELLOW")) return "YELLOW";
  if (set.has("GREEN")) return "GREEN";
  return null;
}

export function formatPrice(price, currency) {
  if (price === null || price === undefined) return null;
  const cur = currency || "EUR";
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency: cur, maximumFractionDigits: 0 }).format(price);
  } catch {
    return `${price} ${cur}`;
  }
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return iso;
  }
}

export function statusLabel(s) {
  return ({
    pending_review: "Pending Review",
    approved_featured: "Approved",
    not_sustainable: "Not Sustainable",
    needs_more_information: "Needs Info",
    archived: "Archived",
  }[s] || s);
}

export function statusBadgeClass(s) {
  return ({
    pending_review: "bg-gray-100 text-gray-700",
    approved_featured: "bg-leaf/10 text-leaf",
    not_sustainable: "bg-clay/10 text-clay",
    needs_more_information: "bg-amber/10 text-amber",
    archived: "bg-gray-200 text-gray-500",
  }[s] || "bg-gray-100 text-gray-700");
}
